import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import BookingForm from "./BookingForm";
import SoldOut from "./SoldOut";
import Highlights from "./Highlights";
import Basics from "./Basics";
import PackageHeader from "./PackageHeader";
import PackageDetailsTab from "./PackageDetailsTab";
import axios from "axios";

function PackageDetailsWrap(props) {

  // API configuration constants
  const API_URL = "https://test.campfr.com/api/get_" + props.ctype + "_workshop/" + props.item_id;
  // const API_URL = "http://localhost:8000/api/list_featured_workshops/";
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;

  // State management for data, loading status, and error handling
  const [workshop, setWorkshop] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    /**
     * Fetches data from the API with authentication token
     */

    const fetchData = async () => {
      try {
        const response = await axios.get(API_URL, {
          headers: { "X-API-TOKEN": API_TOKEN }
        });

        // Update component state with fetched data
        //const workshopArr = Array.isArray(response.data) ? response.data : Object.values(response.data);
        const workshopArr = response.data;
        setWorkshop(workshopArr);
        setLoading(false);
        console.log("hasplaces = "+workshop.hasplaces);
      } catch (error) {
        console.error("API Error:", error);
        setError(error.message || "Failed to fetch API");
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array means this effect runs once on mount

  console.log(error);

  return (
    <>
      <div className="package-details-wrapper pt-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="tour-package-details">
                <PackageHeader workshop={workshop} />
                <PackageDetailsTab workshop={workshop} />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="package-sidebar">
                <Highlights workshop={workshop} />
                <Basics workshop={workshop} />
                {workshop && (                           // only render when loaded
                  workshop.hasplaces
                    ? <BookingForm workshop={workshop} />
                    : <SoldOut ctype={workshop.ctype}
                      srcid={workshop.id}
                      artforms={workshop.artforms} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PackageDetailsWrap;
